import {
	getMilkYieldPerHead,
	roundingNumber,
} from 'components/shared/processes'
import moment from 'moment'
import { COLORS } from 'styles/colors'

type TooltipParams = {
	series: number[][]
	dataPointIndex: number
	w: any
}

export const getMilkYieldTooltip = ({
	series,
	dataPointIndex,
	w,
}: TooltipParams): string => {
	const graph = w?.config?.seriesMeta?.graph
	const graphItem = graph?.[dataPointIndex]
	const sellTotal = graphItem?.sell_milk_sum ?? 0
	const rejectTotal = graphItem?.reject_milk_sum ?? 0
	const dailyTotal = sellTotal + rejectTotal
	const cattleCount = w?.config?.cattleCount ?? w?.config?.cowCount

	// Если данных нет, показать простой тултип
	if (dailyTotal === 0) {
		const dateValue = graphItem?.date
		const dateLabel = dateValue ? moment(+dateValue).format('DD.MM.YY') : ''
		return `
    <div style="position: relative; top: 10px; padding: 6px 8px; font-family: 'Montserrat', sans-serif; font-size: 12px; font-weight: 400; color: ${COLORS.secondary}; background: #ffffff; border-radius: 8px; box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);">
      <div style="display: flex; align-items: center; gap: 6px;">
        <span style="width: 8px; height: 8px; background-color: #7F7F84; border-radius: 50%; display: inline-block;"></span>
        <span style="font-weight: 400; color: #7F7F84;">Нет данных</span>
      </div>
      ${dateLabel ? `<div style="margin-top: 2px; font-weight: 400; color: ${COLORS.secondary}; font-size: 11px;">${dateLabel}</div>` : ''}
    </div>
  `
	}

	const sellPercent = Math.round((sellTotal / dailyTotal) * 100)
	const rejectPercent = sellPercent ? 100 - sellPercent : '-'

	const avgPerHead = getMilkYieldPerHead(dailyTotal, cattleCount)
	const dateValue = graphItem?.date
	const dateLabel = dateValue ? moment(+dateValue).format('DD.MM.YY') : ''

	return `
    <div style="padding: 8px; font-family: 'Montserrat', sans-serif; font-size: 12px; font-weight: 400; color: ${COLORS.secondary}; background: #ffffff; border-radius: 8px; box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);">
      <div style="margin-bottom: 6px; color: ${COLORS.secondary};">
        Среднее на голову: <span style="font-weight: 400; color: #000;">${avgPerHead != null ? roundingNumber(avgPerHead, 1) : '-'} л/голову</span>
      </div>
      <div style="display: flex; align-items: center; gap: 6px; margin-bottom: 4px;">
        <span style="width: 8px; height: 8px; background-color: ${COLORS.blue}; border-radius: 50%; display: inline-block;"></span>
        <span style="color: ${COLORS.secondary};">Товарное молоко</span>
        <span style="font-size: 16px; font-weight: 600; color: #000;">${sellTotal ? roundingNumber(sellTotal, 1).toLocaleString() : '-'}</span>
        <span style="color: ${COLORS.secondary};">л /</span>
        <span style="font-weight: 400; color: #000;">${sellPercent}%</span>
      </div>
      <div style="display: flex; align-items: center; gap: 6px;">
        <span style="width: 8px; height: 8px; background-color: ${COLORS.error}; border-radius: 50%; display: inline-block;"></span>
        <span style="color: ${COLORS.secondary};">Бракованное молоко</span>
        <span style="font-size: 16px; font-weight: 600; color: #000;">${rejectTotal ? roundingNumber(rejectTotal, 1).toLocaleString() : '-'}</span>
        <span style="color: ${COLORS.secondary};">л /</span>
        <span style="font-weight: 400; color: #000;">${rejectPercent}%</span>
      </div>
      <div style="margin-top: 6px; font-size: 11px; color: ${COLORS.secondary};">${dateLabel}</div>
    </div>
  `
}
